module.exports = __webpack_public_path__ + "static/media/liveroom-vip-free.0d13e2cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/liveroom/liveroom-vip-free.png
// module id = 1952
// module chunks = 6